<template>
    <div class="pages">
        <img :src="require('/src/assets/image/pages-success-icon.png')" class="success-icon" alt="">
        <div class="title">领料任务生成完成</div>
        <van-button
            type="warning"
            style="margin-bottom: 24px;"
            @click="handleViewGeneratedTask"
        >查看已生成任务</van-button>
        <van-button
            type="warning"
            plain
            @click="handleBackHome"
        >返回首页</van-button>
    </div>
</template>

<script>
import { Button } from "vant";
export default {
    components:{
        [Button.name]: Button,
    },
    methods: {
        handleViewGeneratedTask(){ 
            window.uni.redirectTo({ url: '/packAdmin/home/generatedTask/index' });
        },
        handleBackHome(){
            window.uni.navigateBack({ delta: 1 });
        }
    }
}
</script>

<style scoped lang="scss">
    .pages {
        padding-top: 119px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .success-icon {
            width: 100px;
            height: 61px;
            margin-bottom: 20px;
        }
        .title {
            font-size: 18px;
            color: #1E1E1E;
            font-weight: bold;
            line-height: 26px;
            margin-bottom: 36px;
        }
        .van-button {
            min-width: 162px;
            height: 36px;
            border-radius: 4px; 
        }
        .van-button--warning {
            background-color: #EC892E;
            border-color: #EC892E;
            color: #FFF;
        }
       .van-button--plain {
            background-color: #FFF;
            border-color: #EC892E;
            color: #EC892E;
        }
    }
</style>